import { render, staticRenderFns } from "./UserFormStep.vue?vue&type=template&id=0fc241a7&"
import script from "./UserFormStep.vue?vue&type=script&lang=js&"
export * from "./UserFormStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports